import {
  type GetTuitionRatePlanResponse,
  GetTuitionRatePlanResponseFromJSON,
} from "@/openapi/generated";

export function parseTuitionRatePlan(
  json: unknown,
): GetTuitionRatePlanResponse {
  const item = (json ?? {}) as Record<string, unknown>;
  return GetTuitionRatePlanResponseFromJSON({
    ...item,
    tiers: Array.isArray(item.tiers) ? item.tiers : [],
  });
}

export function parseTuitionRatePlans(
  json: unknown,
): GetTuitionRatePlanResponse[] {
  if (!Array.isArray(json)) return [];
  return json.map(parseTuitionRatePlan);
}
